import React from 'react';
import '../assets/styles/components/TableIndividual.sass';

const TableIndividual = (props) => {
  const { racers } = props
  return(
    <div className="row">
      <div className="d-none d-sm-block col-sm-12">
        <section className="table-results">
          <div className={`table-results__title --${props.city} table-results__pos-category`}>CLASIFICACIÓN CATEGORÍA</div>
          <div className={`table-results__title --${props.city} table-results__pos-overall`}>CLASIFICACIÓN GENERAL</div>
          <div className={`table-results__title --${props.city} table-results__category`}>CATEGORÍA</div>
          <div className={`table-results__title --${props.city} table-results__number`}>NÚMERO CORREDOR</div>
          <div className={`table-results__title --${props.city} table-results__racer`}>NOMBRE DEL CORREDOR</div>
          <div className={`table-results__title --${props.city} table-results__time`}>TIEMPO TOTAL</div>
          <div className={`table-results__title --${props.city} table-results__time`}>TIEMPO DIFERENCIA</div>
          
          {racers.map( (racer, i) => (
            <>
              <div className="table-results__pos-category racer__red">{racer.dnf === 'S' ? '-' : racer.category_rank}</div>
              <div className="table-results__pos-overall">{racer.dnf === 'S' ? '-' : racer.overall_rank}</div>
              <div className="table-results__category">{racer.category_es}</div>
              <div className="table-results__number">
                <p>{racer.number}</p>
              </div>
              <div className="table-results__racer">
                <p><img src={`https://legendofeldorado.com/2018/en/img/banderas/${racer.country_en}.png`} alt=""/> {racer.racer}</p>
              </div>
              <div className="table-results__time"><p>{racer.dnf === 'S' ? '-' : racer.time}</p></div>
              <div className="table-results__time racer__red"><p>{racer.dnf === 'S' ? '-' : racer.difference}</p></div>
            </>
          ))}
        </section>

      </div>
      <div className="d-block d-sm-none col-xs-12">
        <section className="col-12 table-results-mobile">
          {racers.map( (racer, i) => (
            <div className="table-results-mobile__item" key={i}>
              <p><b>Clasificación categoría:</b> {racer.dnf === 'S' ? '-' : racer.category_rank}</p>
              <p><b>Clasificación general:</b> {racer.dnf === 'S' ? '-' : racer.overall_rank}</p>
              <p><b>Categoría:</b> {racer.category_es}</p>
              <p><b>Corredor:</b></p>
              <span className="table-results-mobile__item--racer">{racer.number} <img src={`https://legendofeldorado.com/2018/en/img/banderas/${racer.country_en}.png`} alt=""/> {racer.racer}</span>
              <p>
                <b>Tiempo total: </b> 
                {racer.dnf === 'S' ? '-' : racer.time}
              </p>
              <p>
                <b>Tiempo total: </b> 
                {racer.dnf === 'S' ? '-' : racer.difference}
              </p>
            </div>
          ))}
        </section>
      </div>
    </div>
  )
}

export default TableIndividual;
